import { LogicTabListCombinedProps } from './types';

const usePresenter = (props: LogicTabListCombinedProps): LogicTabListCombinedProps => {
  return props;
};

export default usePresenter;
